import GoogleAnalytics from 'react-ga';
import {get} from 'lodash';

const gaOptions = {
  debug: false
};

GoogleAnalytics.initialize(GA_KEY, gaOptions);


const trackPage = page => {
  GoogleAnalytics.pageview(page);
};


export default function(history) {
  const getPath = location => get(location, 'pathname', '/');

  trackPage(getPath(history.location));

  history.listen(location => trackPage(getPath(location)));
}
